import { Injectable } from '@angular/core';
import { StorageService } from 'src/assets/lib/eaf-ng2-module';
import { AppConsts } from 'src/shared/AppConsts';
import { XmlHttpRequestHelper } from 'src/shared/helpers/XmlHttpRequestHelper';

@Injectable({ providedIn: 'root' })
export class AppAuthService {
  constructor(private storageService: StorageService) {}

  logout(reload?: boolean, returnUrl?: string): void {
    const customHeaders = {
      'Eaf.TenantId': eaf.multiTenancy.getTenantIdCookie(),
      'Authorization': 'Bearer ' + eaf.auth.getToken(),
    };

    XmlHttpRequestHelper.ajax('GET', AppConsts.remoteServiceBaseUrl + '/api/TokenAuth/LogOut', customHeaders, null, () => {
      eaf.auth.clearToken();
      this.storageService.Clear();
      this.storageService.setCookieValue(eaf.auth.tokenCookieName, undefined, undefined, eaf.appPath);
      this.storageService.setCookieValue(AppConsts.authorization.encrptedAuthTokenName, undefined, undefined, eaf.appPath);

      if (reload !== false) {
        if (returnUrl) {
          location.href = returnUrl;
        } else {
          location.href = '';
        }
      }
    });
  }
}
